'use strict';
class ImageArchiveFilter {
    constructor() {
        this.url = window.location.href.split('?')[0];
        this.setup();
    }
    setup() {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        if (document.location.hash) {
            let imageContainer = document.querySelector(document.location.hash);
            imageContainer && imageContainer.scrollIntoView();
        }
        this.form = document.querySelector('.filter-section form.form');
        if (!this.form) {
            return;
        }
        this.form.querySelector(".reset_button").addEventListener('click', (e) => {
            location.replace(this.url);
            e.preventDefault();
        });

        this.imageArchiveArea = document.querySelector('.image-archive-area');
        this.addSearchTextSrOnly = document.querySelector('#searchresultText');
        this.form.addEventListener('change', (e) => {
            this.formChange(e);
        });
        this.form.addEventListener('submit', (e) => {
            console.log("Intercepted submit!");
            e.preventDefault();
            this.formChange(e);
        });
        this.form.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                this.formChange(e);
            }
        });
    }


  formChange(e) {
    const data = new URLSearchParams();
    for (const pair of new FormData(this.form)) {
      data.append(pair[0], pair[1]);
    }
    const newUrl = `${this.url}?${data.toString()}`;
    const hitArea = document.querySelector(".hit-area");
    hitArea.style.opacity = 0.3;
    this.imageArchiveArea.classList.add("search-load");
    this.filterHits(newUrl, 
        e => {
      const activeElementId = document.activeElement && document.activeElement.id;
      window.history.replaceState(null, null, newUrl);
      var element = document.createElement("div");
      element.insertAdjacentHTML("beforeend", e);
      this.imageArchiveArea.innerHTML = element.innerHTML;
      const hitsMessage = element.querySelector("#hits-message");
      if (hitsMessage) {
        this.addSearchTextSrOnly.innerHTML = "Sökresultat:" + hitsMessage.innerHTML;
      }
      this.setup();
      window.searchPaginator.setup();
      this.imageArchiveArea.classList.remove("search-load");
      if (activeElementId) {
        const focusThis = document.getElementById(activeElementId);
        if (focusThis) {
          focusThis.focus();
          focusThis.select && focusThis.select();
        }
      }
    });
  }

    filterHits(url, callback) {
        var headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With': 'filter'
        };

        fetch(url,
            {
                headers: headers,
                method: 'GET',
                credentials: 'include'

            }).then(resp => {
            return resp.text();
          }).then(data => {
            console.log(url);
            callback(data);
        });
    }

}

class UpdateYears{
    constructor(form) {
        this.setup();
        this.form = form;
    }
    setup() {
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new ImageArchiveFilter();
});






// WEBPACK FOOTER //
// ./Components/ImageArchive/ImageArchiveFilter.js